/**
 * What to do with the error Supabase returns when a new password is saved.
 *
 * There are no password rules in this app: any non-empty password is fine,
 * and typing the one you already have is not a failure. Supabase refuses a
 * save that leaves the password unchanged ("same_password"); to the owner that
 * is simply done. Anything else the server rejects is shown with its own words,
 * so a rule set on the Supabase side is visible instead of looking like a
 * dropped connection.
 */
export type SaveOutcome = { kind: 'done' } | { kind: 'signal' } | { kind: 'rejected'; reason: string };

export function saveOutcome(error: { message: string; code?: string } | null): SaveOutcome {
  if (!error) return { kind: 'done' };
  if (error.code === 'same_password' || /different from the old password/i.test(error.message)) {
    return { kind: 'done' };
  }
  if (/fetch|network/i.test(error.message)) return { kind: 'signal' };
  return { kind: 'rejected', reason: error.message };
}
